export const showAddTermsModal = () => {
    return {
      type: "SHOW_ADD_TERMS_MODAL",
    };
  };
  
  export const hideAddTermsModal = () => {
    return {
      type: "HIDE_ADD_TERMS_MODAL",
    };
  };
  